import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import moment from 'moment';

import {
  InfoWindow,
  TrafficLayer,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
} from 'react-google-maps';

import _ from 'underscore';
import { withTranslation } from 'react-i18next';

const Map = withGoogleMap((props) => {
  let path;
  if (props.waypoints.length > 30) {
    path = props.waypoints
      .filter((item, index) => {
        return index % 3 === 0;
      })
      .map((item, idx) => {
        return {
          timestamp: item.timestamp,
          lat: item.position.lat,
          lng: item.position.lng,
          mapKey: item.timestamp + idx,
        };
      });
  } else {
    path = props.waypoints.map((item, idx) => {
      return {
        timestamp: item.timestamp,
        lat: item.position.lat,
        lng: item.position.lng,
        mapKey: item.timestamp + idx,
      };
    });
  }

  return (
    <GoogleMap defaultZoom={10} defaultCenter={props.center}>
      <TrafficLayer autoUpdate />
      {path.map((stop) => {
        return (
          <Marker
            key={stop.mapKey}
            noRedraw
            icon={{
              url: '/img/waypoint.png',
              scaledSize: new google.maps.Size(20, 20),
            }}
            onMouseOut={() => props.onMouseOut()}
            onMouseOver={() => props.onMouseOver(stop.timestamp)}
            position={stop}
          >
            {props.visibleMarker === stop.timestamp && (
              <InfoWindow>
                <div>{moment(stop.timestamp).calendar()}</div>
              </InfoWindow>
            )}
          </Marker>
        );
      })}
      <Polyline
        path={path}
        geodesic
        defaultVisible
        visible
        options={{
          strokeColor: '#25AA82',
          strokeWeight: 2,
        }}
      />
      {props.markers}
    </GoogleMap>
  );
});

class ShipmentMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: null,
    };
  }

  handleMouseOut() {
    this.setState({ visible: null });
  }

  handleMouseOver(visible) {
    this.setState({ visible });
  }

  render() {
    const shipment = this.props.shipment;
    const center = _.pick(shipment.origin[0], 'lat', 'lng');
    let markers = [];
    const { t } = this.props;
    shipment.stops.forEach((stop, idx) => {
      markers.push(
        <Marker
          key={stop._id}
          icon={{ url: `/img/stop-${stop.sequence}.png` }}
          position={stop.location[0]}
        >
          <InfoWindow>
            <div>{stop.location[0].address}</div>
          </InfoWindow>
        </Marker>,
      );
    });

    if (shipment.driver && shipment.current) {
      const driverCoords = {
        lat: shipment.driver.coords[1],
        lng: shipment.driver.coords[0],
      };
      markers.push(
        <Marker
          icon={{ url: '/img/working-truck.png' }}
          position={driverCoords}
          key={shipment.driver._id}
        />,
      );
    }

    const enabled = this.props.showWaypoints ? t('ENABLED') : t('DISABLED');

    return (
      <div>
        <Button
          onClick={() => this.props.onWaypointsSelect()}
          style={{ margin: 7, zIndex: 40, position: 'absolute' }}
          bsStyle={this.props.showWaypoints ? 'success' : 'default'}
        >
          {t('WAYPOINTS_ENABLED', { enabled })}
        </Button>
        <Map
          googleMapURL="https://maps.googleapis.com/maps/api/js?client=gme-cargomaticinc&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: this.props.height }} />}
          mapElement={<div style={{ height: `100%` }} />}
          waypoints={this.props.waypoints}
          center={center}
          markers={markers}
          visible={this.state.visible}
          onMouseOver={(id) => this.handleMouseOver(id)}
          onMouseOut={this.handleMouseOut.bind(this)}
          visibleMarker={this.state.visible}
        />
      </div>
    );
  }
}

export default withTranslation()(ShipmentMap);
